import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { deepOrange, grey, red } from '@material-ui/core/colors';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';


//models
import Message, { MessageDirection } from '../models/Message';
import { errorMessage } from '../models/Constants';

const useStyles = makeStyles((theme) => ({
    adi: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      borderRadius:20,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 0,
    },
    user: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
      borderRadius:20,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 0,
    },
    error: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      borderRadius:20,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
    },
  }));

const MessageBox = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    if (!message.messageData) {
      message.messageData = errorMessage[Math.floor(Math.random() * errorMessage.length)];
    }
    
    if(message.messageDirection===MessageDirection.RECEIVED){
      return (
        <motion.div
          animate={{
            x:[0,5,0],
            rotate:[0,-2,0,2,0]
          }}
          transition={{duration: 0.3}}
        >
          <Paper elevation={0} className={classes.adi}>
              {parse(message.messageData)}
          </Paper>
        </motion.div>
    );
    }
    else if(message.messageDirection===MessageDirection.SENT) {
      return (
        <motion.div
          animate={{
            x:[0,-5,0],
            rotate:[0,2,0,-2,0]
          }}
          transition={{duration: 0.3}}
        >
          <Paper className={classes.user}>
            {parse(message.messageData)}
          </Paper>
        </motion.div>
    );
    }
    else{
      return (
        <motion.div
          animate={{
            x:[0,5,0],
            rotate:[0,2,0]
          }}
          >
          <Paper elevation={0} className={classes.error}>
              {errorMessage[Math.floor(Math.random() * errorMessage.length)]}
          </Paper>
        </motion.div>
    );
    }
    
};

export default MessageBox;